(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-price-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-price-filter')) {
    customElements.define('collection-price-filter', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.low = this.querySelector('[data-price-min]');
        this.high = this.querySelector('[data-price-max]');
        this.lower = this.querySelector('[data-range-min]');
        this.upper = this.querySelector('[data-range-max]');
        this.limit = Number(this.upper.max);
        if (this.closest('collection-filters-form')) {
          this.parameters = [this.low, this.high].map(input => {
            const parameter = document.createElement('input');
            parameter.type = 'hidden';
            parameter.name = input.name;
            input.removeAttribute('name');
            this.append(parameter);
            return parameter;
          });
        }
        this.formatter = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'AUD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
        this.addEventListener('input', event => {
          event.stopPropagation();
          if (event.target.type === 'range') this.sync(event.target);
        });
        this.addEventListener('change', event => {
          event.stopPropagation();
          this.sync(event.target);
          this.apply();
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Enter' && event.target.type === 'number') {
            event.preventDefault();
            event.target.blur();
          }
        });
        this.sync(this.high);
      }
      sync(source) {
        const isLow = source === this.lower || source === this.low;
        let from = Number(this.low.value || 0);
        let to = Number(this.high.value || this.limit);
        if (source === this.lower) from = Number(source.value);
        if (source === this.upper) to = Number(source.value);
        from = Math.min(this.limit, Math.max(0, Math.round(from)));
        to = Math.min(this.limit, Math.max(0, Math.round(to)));
        if (isLow) from = Math.min(from, to);
        else to = Math.max(from, to);
        this.low.value = from.toFixed(0);
        this.high.value = to.toFixed(0);
        this.lower.value = from;
        this.upper.value = to;
        this.lower.disabled = this.upper.disabled = this.limit === 0;
        this.lower.style.zIndex = from === this.limit ? '2' : '0';
        this.style.setProperty('--price-from', `${this.limit ? from / this.limit * 100 : 0}%`);
        this.style.setProperty('--price-to', `${this.limit ? to / this.limit * 100 : 0}%`);
        this.lower.setAttribute('aria-valuetext', this.formatter.format(from));
        this.upper.setAttribute('aria-valuetext', this.formatter.format(to));
        this.querySelector('output').textContent = `${this.formatter.format(from)} – ${this.formatter.format(to)}`;
        if (this.parameters) {
          this.parameters[0].value = from.toFixed(0);
          this.parameters[1].value = to.toFixed(0);
          this.parameters[0].disabled = from === 0;
          this.parameters[1].disabled = to === this.limit;
        }
      }
      apply() {
        const form = this.closest('collection-filters-form')?.querySelector('form');
        if (form) {
          form.dispatchEvent(new Event('input', { bubbles: true }));
          return;
        }
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        [[this.low, 0], [this.high, this.limit]].forEach(([input, boundary]) => {
          if (Number(input.value) === boundary) url.searchParams.delete(input.name);
          else url.searchParams.set(input.name, input.value);
        });
        const tags = this.closest('.m-filter--wrapper')?.querySelector('collection-tags-filters');
        if (tags && typeof tags.fetchSectionHtml === 'function') tags.fetchSectionHtml(url.toString());
        else window.location.assign(url.toString());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
